import React from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";

import PageHero from "../components/PageHero";
import ShellCard from "../components/ShellCard";
import { useAuth } from "../hooks/auth";
import { rotaInicial } from "./products";

// Página "Sem acesso" do guard de URL (PO1-2381, épico PO1-2374): aparece quando
// o usuário entra pela URL numa tela cujo item de menu ele não vê (mesma regra,
// nodeMatchesPermission). Visual no padrão do Hub (PageHero + ShellCard), sem
// redirecionar em silêncio: a pessoa entende o que faltou e tem para onde ir.

export default function SemAcesso({ permissao }) {
  const { user } = useAuth();
  const permissoes = Array.isArray(permissao) ? permissao : permissao ? [permissao] : [];
  return (
    <div className="content" data-testid="sem-acesso">
      <PageHero
        eyebrow="Acesso"
        title="Sem acesso"
        description="Seu usuário não tem permissão para esta tela. Se precisar dela, peça ao administrador do seu embarcador para liberar o acesso."
      />
      <ShellCard title="O que fazer" description="Você continua com acesso normal às outras telas do menu.">
        <div role="alert" style={{ marginBottom: "0.75rem" }}>
          {permissoes.length ? (
            <small>
              Permissão necessária: <code>{permissoes.join(" ou ")}</code>
            </small>
          ) : null}
        </div>
        <Button tag={Link} to={rotaInicial(user)} color="primary" size="sm">
          Ir para o início
        </Button>
      </ShellCard>
    </div>
  );
}
